import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Title from '../dev/Title'
import Input from '../dev/Input'
import Submit from '../dev/Submit'
import Response from '../dev/Response'

const { REACT_APP_URI = '/' } = process.env
class ResetPassword extends Component {
    state = {
        registerPassword: '',
        nextRegisterPassword: '',
        isPasswordMatch: '',
        isButtonActive: false,
        response: '',
    }
    isEmail = email => {
        const regex = /^([a-zA-Z0-9_.\-+])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!regex.test(email)) {
            return false;
        }
        else {
            return true;
        }
    }
    profileInput = condition => e => {
        const { target: { value } } = e;
        this.setState({ [`${condition}`]: value }, () => this.matchPassword())
    }
    matchPassword = () => {
        const { registerPassword, nextRegisterPassword } = this.state
        if (registerPassword === '' || nextRegisterPassword === '') return;
        if (registerPassword === nextRegisterPassword) this.setState({ isPasswordMatch: true })
        else this.setState({ isPasswordMatch: false })
    }
    profileSubmit = () => {
        const { match: { params: { id } }, messages } = this.props
        if (this.isButtonActive() === 'disabled') return
        const { token } = this.props.user
        const { registerPassword } = this.state
        fetch(`${REACT_APP_URI}/accounts/setPassword/${id}/`, {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": token,
            },
            body: JSON.stringify({ password: registerPassword })
        })
        .then(res => {
            if (res.status === 200) {
                this.setState({ response: messages.user_reset_successfully, isLoading: false }, () => setTimeout(() => {
                    this.props.history.push('/');
                    this.props.dispatch({ type: 'toggleUserField', condition: 'signIn' });
                }, 3000))
            }
        })
    }
    isButtonActive = () => {
        if (this.state.isPasswordMatch) return ''
        else return 'disabled'
    }
    render() {
        const { registerPassword, nextRegisterPassword, isPasswordMatch, response } = this.state
        const { profileInput, profileSubmit, isButtonActive } = this
        const { match: {params: {email} }, messages } = this.props
        return (
            <SetPasswordWrap>
                <Title>{messages.user_reset_password}</Title>
                <Email>{email}</Email>
                <Input
                    onInput={profileInput('registerPassword')} value={registerPassword}
                    onKeyPress={e => e.key === "Enter" && profileSubmit()}
                    type="password" placeholder={messages.user_password_signup}/>
                <Input
                    onInput={profileInput('nextRegisterPassword')} value={nextRegisterPassword}
                    onKeyPress={e => e.key === "Enter" && profileSubmit()}
                    type="password" placeholder={messages.user_confirm_password} />
                {isPasswordMatch === false && <Response>{messages.user_password_not_match}</Response>}
                <Submit onClick={profileSubmit} disabled={isButtonActive()}>{messages.user_reset_password}</Submit>
                {response !== '' && <Response>{response}</Response>}
            </SetPasswordWrap>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages
    }
}
export default withRouter(connect(mapStateToProps)(ResetPassword));
const SetPasswordWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 350px;
    min-height: 270px;
    padding: 48px;
    background-color: #fff;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
    /* border: solid 0.5px #a0a0a0; */
`
const Email = styled.div`
    margin-bottom: 16px;
`


// WEBPACK FOOTER //
// ./src/User/UserActive/SetPaaword.js